import React from "react";
import locale from "@bonliva-crm/locale";
import { ConsultantQualityCheckDataFragment } from "@bonliva-crm/graphql";
import { QualityCheckMeta } from "./quality-check-meta";
import { formatLabelDate } from "./utils";

type QualityCheckStatusExpiresOnProps = {
  data: ConsultantQualityCheckDataFragment;
};

export default function QualityCheckStatusExpiresOn({
  data
}: QualityCheckStatusExpiresOnProps) {
  if (!data.ExpiresOn) {
    return null;
  }

  return (
    <QualityCheckMeta
      title={locale.Expires}
      description={formatLabelDate(data.ExpiresOn)}
    />
  );
}
